import {Button, Space} from "antd";
import React, {ComponentProps, useEffect, useState} from "react";
import * as api from '../../../apis/salesOrder'
import {useRequest} from "ahooks";
import * as minio from '../../../utils/minio'

type ReportsTabProps = ComponentProps<any> & {
    orderId: number
}

function ReportsTab(props: ReportsTabProps) {

    const orderId = props.orderId
    const [items, setItems] = useState<Array<any>>([])

    useEffect(() => {
        if (orderId)
            run(orderId)
    }, [orderId])

    const {loading, run} = useRequest(api.getQualityInspectionReport, {
        manual: true,
        onSuccess: (res) => {
            setItems(res.data.data)
        }
    })

    function downloadAll() {
        items.forEach(item => {
            window.open(minio.getUrl(item.path))
        })
    }

    return (
        <div>
            <table
                style={{
                    width: '100%',
                    textAlign: "center",
                    borderCollapse: 'collapse',
                    borderColor: 'rgba(5, 5, 5, 0.06)'
                }}
                border={1}
                cellSpacing={0} cellPadding={0}>
                <thead>
                <tr style={{backgroundColor: 'rgba(0, 0, 0, 0.02)', height: 40}}>
                    <td width={'20%'}>商品编号</td>
                    <td width={'20%'}>批号</td>
                    <td width={'20%'}>
                        出库批次质检报告
                        {items?.length > 0 && (
                            <a style={{marginLeft: 5}} onClick={downloadAll}>下载全部</a>
                        )}
                    </td>
                </tr>
                </thead>
                <tbody>
                {items.length > 0 ? items.map((item: any) => (
                        <tr style={{height: 40}}>
                            <td>{item.code}</td>
                            <td>{item.batchNo}</td>
                            <td><a onClick={() => window.open(minio.getUrl(item.path.replace('#', '%23')))}>查看</a></td>
                        </tr>
                    )) :
                    <tr>
                        <td colSpan={3} style={{height: 40}}>暂无质检报告</td>
                    </tr>
                }
                </tbody>
            </table>
        </div>
    )
}

export default ReportsTab;
